import React from "react";
import LegalPage from "../components/LegalPage";

export default function Refund() {
  return (
    <LegalPage
      testId="refund-page"
      eyebrow="Legal"
      title="Refund Policy"
      lastUpdated="February 2026"
    >
      <p>
        We want you to feel confident subscribing to BizPulse AI. This Refund Policy explains when and
        how you can request a refund. It applies to all paid plans, monthly and lifetime, sold through
        our merchant of record, Paddle.
      </p>

      <h2>1. How Billing Works</h2>
      <p>
        Subscriptions are billed in advance for each billing period. Monthly plans renew automatically
        on the same calendar day each month until cancelled. Lifetime plans are a single one-time
        payment for perpetual access to the features described at the time of purchase. Paddle.com Inc.
        is the merchant of record for all transactions and appears on your invoice and card statement.
      </p>

      <h2>2. 14-Day Money-Back Window</h2>
      <p>
        We offer a full refund on your <strong>first paid invoice</strong> if you request it within
        <strong> 14 days</strong> of the invoice date. This applies to both monthly and lifetime plans.
        No reason required &mdash; if it&rsquo;s not the right fit, we&rsquo;ll refund you.
      </p>

      <h2>3. Renewal Charges</h2>
      <p>
        Subsequent monthly renewal charges are <strong>non-refundable by default</strong>. We will,
        however, review refund requests for renewals on a case-by-case basis &mdash; for example if the
        Service was unavailable for an extended period, if the renewal was charged after a clearly
        documented cancellation attempt, or in cases of demonstrable hardship. Decisions are made at
        our reasonable discretion.
      </p>

      <h2>4. How to Request a Refund</h2>
      <p>
        Email <a href="mailto:contact@bizpulseai.net">contact@bizpulseai.net</a> from the email address
        linked to your BizPulse AI account and include:
      </p>
      <ul>
        <li>The email address on the subscription;</li>
        <li>The plan you&rsquo;re subscribed to (Starter / Professional / Enterprise, monthly or lifetime);</li>
        <li>The invoice number or Paddle transaction reference, if you have it;</li>
        <li>A brief reason for the refund (optional within the 14-day window; required for renewal-charge requests).</li>
      </ul>
      <p>We&rsquo;ll acknowledge your request within two business days and confirm the outcome by email.</p>

      <h2>5. How Refunds Are Processed</h2>
      <p>
        Because Paddle is our merchant of record, refunds are processed by Paddle on our behalf back to
        the original payment method (credit card, PayPal, etc.). You do not need to contact Paddle
        directly &mdash; we will initiate the refund for you once approved.
      </p>
      <p>
        Once issued, refunds typically take <strong>5 to 10 business days</strong> to appear on your
        statement, depending on your bank or payment provider. International transactions and currency
        conversions may take slightly longer.
      </p>

      <h2>6. What Happens to Your Account</h2>
      <p>
        When a refund is issued for a monthly invoice, your subscription is cancelled and access to
        paid features ends immediately. When a refund is issued for a lifetime plan, your lifetime
        access ends at the same time. Your account itself remains and you can continue using free
        features.
      </p>

      <h2>7. Chargebacks</h2>
      <p>
        Please contact us before filing a chargeback &mdash; we can usually resolve the issue faster and
        without affecting your account standing. Unjustified chargebacks may result in account
        suspension and recovery of associated processing fees.
      </p>

      <h2>8. Contact</h2>
      <p>
        Refund requests and billing questions:{" "}
        <a href="mailto:contact@bizpulseai.net">contact@bizpulseai.net</a>.
      </p>
    </LegalPage>
  );
}
